import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    SupplierQuestionnairePatch,
    UpdateSupplierQuestionnaireDocument,
} from "../../../../../../../generated/client/graphql";
import { useGraphQLMutation } from "../../../../../../QueryClientWithHeaders";
import { useSetToast } from "../../../../../../components/Toast";
import { supplierKeys } from "../../../data";

export const useUpdateSupplierQuestionnaire = (questionnaireId?: string) => {
    const updateQuestionnaireMutation = useGraphQLMutation(
        UpdateSupplierQuestionnaireDocument,
    );

    const client = useQueryClient();
    const { t } = useTranslation("SupplierTable");
    const { setToastSuccess } = useSetToast();

    const updateQuestionnaire = async (patch: SupplierQuestionnairePatch) => {
        if (!questionnaireId) {
            return;
        }
        await updateQuestionnaireMutation.mutate(
            {
                id: questionnaireId,
                patch,
            },
            {
                onSuccess: () => {
                    setToastSuccess(t("questionnaire_updated_success"));
                    client.invalidateQueries({
                        queryKey: supplierKeys.all,
                    });
                },
            },
        );
    };

    return { updateQuestionnaire };
};
